import { Link, useLocalSearchParams } from 'expo-router';
import EventDetailBannerClock, {
  EventDetailBannerClockFragment,
} from '@/components/Event/EventDetailBannerClock';
import ActionButton from '@/components/UI/ActionButton';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';
import eventStatus from '@/utils/eventStatus';
import { BackgroundFilter } from '../../components/Event/EventBanner';

export const EventDetailBannerInfoFragment = graphql(/* GraphQL */ `
  fragment EventDetailBannerInfo on event {
    id
    status
    permissions
    event_clock {
      event_id
    }
    ...EventDetailBannerClock
  }
`, [EventDetailBannerClockFragment]);

export default function EventDetailBannerInfo({
  fragment,
}: {
  fragment: FragmentOf<typeof EventDetailBannerInfoFragment>;
}) {
  const { eventId } = useLocalSearchParams<{ eventId?: string }>();
  const event = readFragment(EventDetailBannerInfoFragment, fragment);
  const hasClock = !!event?.event_clock?.event_id;
  const canEditScore = !!event?.permissions?.edit_score;

  return canEditScore || event?.status || hasClock ? (
    <Box direction="vertical" justify="center" align="center" minWidth={32}>
      <BackgroundFilter opacity={0.4} />
      <Box
        direction="vertical"
        px="xl"
        space="md"
        justify="center"
        align="center"
      >
        {canEditScore ? (
          <Link
            asChild
            href={{
              pathname: '/event/[eventId]/scorekeeping/score',
              params: { eventId },
            }}
          >
            <ActionButton
              accessibilityLabel="Edit score"
              icon="create-outline"
              iconVariant="white"
              label="Edit score"
              labelVariant="white"
              testID="EventBannerEditScore"
              variant="secondary"
            />
          </Link>
        ) : null}
        {event?.status ? (
          <Text variant="white" size="xs">
            {eventStatus[event.status]}
          </Text>
        ) : null}
      </Box>
      {hasClock ? <EventDetailBannerClock fragment={event} /> : null}
    </Box>
  ) : null;
}
